import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrieveAccordion } from "../../redux/slice/accordion-slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Banner from "./components/eu-combo-banner";
import LoadingComp from "../../components/re-usable/loading/loading";
import PageNotFound from "../errors/page-not-found";

const EUComboProds = () => {
  const { "*": urlPath } = useParams();
  const formattedPath = urlPath?.replaceAll("/", "%2F");
  const breadcrumbPath = `eucomboprods%2F${formattedPath}`;
  const path = `%2F${breadcrumbPath}`;
  const accordionPath = `${path}%2FAccordion-Items`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);
  const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  const [isPublished, setIsPublished] = useState(false);
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);

  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (!pageMenuLoading)
      dispatch(retrievePageMenu(path));

    dispatch(retrieveAccordion(accordionPath));
  }, [path]);

  useEffect(() => {
    if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
    else if (pageMenuData[0]) {
      setIsPublished(true);
    }
  }, [pageMenuData]);

  useEffect(() => {
    if (isPublished) {
      if (pageMenuData[0].result[0]?.javaScriptField) setScriptHtmlString(pageMenuData[0].result[0]?.javaScriptField);
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName.replace(" | RAPS", '')}</title>
      </Helmet>
      <Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <br />
        <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description, }}></div>
      <RegisterStyleComponent />
      {AccordionData[0]?.data && (
        <div className="container">
          <div className="col-md-12">
            <Accordion alwaysOpen flush className="convergence convergence-primary">
              {AccordionData[0]?.data?.map((item, index) => {
                return (
                  <Card key={index}>
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Card.Header>
                        <Accordion.Header className="btn btn-block heading">
                          <span className="heading">
                            <strong dangerouslySetInnerHTML={{ __html: item.name }}></strong>
                            <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow">
                              &nbsp;
                            </i>
                          </span>
                        </Accordion.Header>
                      </Card.Header>
                      <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                    </Accordion.Item>
                  </Card>
                );
              })}
          </Accordion>
          <div>&nbsp;</div>
          </div>
        </div>
        )}
    </>
  );
};

export default EUComboProds;
const RegisterStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .heading { float: left; white-space: break-spaces; }
          .convergence .accordion-button{
            font-size: 1rem;
          }
          .accordion-button:not(:disabled):not(.disabled):active, .accordion-button:not(:disabled):not(.disabled).active{
            color: #186DB4;
            background-color: #fff;
            border-color: #186DB4;
          }
          .table{
            margin-top: 0;
            font-size: 1rem
          }
          .accordion .card{
            margin-top: 0;
            margin-bottom: 0;
          }
          .convergence .accordion-button{
            font-weight: 700;
            text-transform: uppercase;
          }
          .lead{
            margin-bottom: 0;
          }
          .table td, th{
            margin-top: 0;
            font-size: 1rem;
            padding: 0.75rem !important;
          }
          .heading{
            color: inherit;
          }
          .accordion-item .card-header{
            width: 100%;
            display: flex
          }
          .card-body{
            padding: 1.25rem;
          }
          .btn-success {
            background-color: #799C4B !important;
            border-color: #799C4B !important;
          }
        `}
      </style>
    </>
  );
};